/* eslint-disable no-eval */
import PropTypes from 'prop-types';
// @mui
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// hooks
import { usePendingRegistration } from '@/hooks/usePendingRegistration';
import useResponsive from '../../hooks/useResponsive';
// config
import { HEADER, HEADER_ALERT, NAV } from '../../config-global';
// components
import { useSettingsContext } from '../../components/settings';

// ----------------------------------------------------------------------

const SPACING = 8;

Main.propTypes = {
  sx: PropTypes.object,
  children: PropTypes.node,
};

export default function Main({ children, sx, ...other }) {
  const { themeLayout } = useSettingsContext();

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const isDesktop = useResponsive('up', 'lg');

  const { shouldShowPendingRegistrationAlert } = usePendingRegistration();
  const showPendingRegistrationAlert = shouldShowPendingRegistrationAlert;

  const theme = useTheme();
  // Fundo do painel: gradiente diagonal preto -> verde Cakto, so no dark (~70% preto / 30% verde, leve).
  // Posicao/stops/cor sao ajustaveis aqui. backgroundAttachment fixed deixa o verde ancorado no canto da viewport.
  const panelBg =
    theme.palette.mode === 'dark'
      ? {
          background: `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${theme.palette.background.default} 65%, ${theme.palette.primary.main} 120%)`,
          backgroundAttachment: 'fixed',
        }
      : {};

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          pt: `${HEADER.H_MOBILE + HEADER_ALERT.HEIGHT(showPendingRegistrationAlert) + SPACING}px`,
          pb: `${HEADER.H_MOBILE + SPACING}px`,
          ...(isDesktop && {
            px: 2,
            pt: `${
              HEADER.H_DASHBOARD_DESKTOP + HEADER_ALERT.HEIGHT(showPendingRegistrationAlert) + 80
            }px`,
            pb: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          }),
          ...panelBg,
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        pt: `${HEADER.H_MOBILE + HEADER_ALERT.HEIGHT(showPendingRegistrationAlert) + SPACING}px`,
        pb: `${HEADER.H_MOBILE + SPACING}px`,
        ...(isDesktop && {
          px: 2,
          pt: `${
            HEADER.H_DASHBOARD_DESKTOP + HEADER_ALERT.HEIGHT(showPendingRegistrationAlert) + SPACING
          }px`,
          pb: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`,
          }),
        }),
        ...panelBg,
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
